<script>
export default {
    methods: {
        close() {
            this.$emit('closed')
        }
    }
}
</script>